import { IconButton, Tooltip, Typography } from '@mui/material';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import { GridEntry } from '../entry/GridEntry';

export const ReportEntry = ({id, productName, duration, temperature, crispyness, innerCrispyness, handleChangeSearch})  =>
{
    function renderCardContent (productName, duration, temperature, crispyness, innerCrispyness) {
      return (<>
        <Typography gutterBottom variant="h6" component="div">
          {productName}
        </Typography>
        <Typography color='secondary' marginBottom={'2px'} alignItems={'center'} display={'flex'}><strong>Temperatur:</strong> &nbsp;&nbsp;{temperature}°C</Typography>
        <Typography color='secondary' marginBottom={'2px'} alignItems={'center'} display={'flex'}><strong>Dauer:</strong> &nbsp;&nbsp;{duration} min</Typography>
        <Typography color='secondary' marginBottom={'2px'} alignItems={'center'} display={'flex'}><strong>Krossheit:</strong> &nbsp;&nbsp;{crispyness}</Typography>
        <Typography color='secondary' marginBottom={'10px'} alignItems={'center'} display={'flex'}><strong>Innere Krossheit:</strong> &nbsp;&nbsp;{innerCrispyness}</Typography>
      </>
      )
    };

    function renderCardActions (id, handleChangeSearch) {

      const handleDelete = (id) => {
          const requestOptions = {
            method: 'DELETE'
          };
          fetch('/api/report/'+id, requestOptions)
          .then(r => handleChangeSearch({target: {value: ""}}))
          .catch(err => console.error(err));
      };

      return(<>
        <Tooltip title='bearbeiten'>
          <IconButton href={"/report/edit/"+id} size="medium" color="secondary" aria-label="edit">
              <EditIcon fontSize="medium" />
          </IconButton>
        </Tooltip>
        <Tooltip title='löschen'>
          <IconButton onClick={(event)=> handleDelete(id)} size="medium" color="error" aria-label="delete">
              <DeleteIcon fontSize="medium" />
          </IconButton>
        </Tooltip>
      </>);
    };

    return (
      <GridEntry
        cardContent={renderCardContent(productName, duration, temperature, crispyness, innerCrispyness)}
        cardActions={renderCardActions(id, handleChangeSearch)}
        expandContent={null}
        useSmall={false}
       />
    );
};